import { updateUserPassword } from '../services/userService'

function fetchUpdatePassword(data) {
  return () => updateUserPassword(data)
}

export default fetchUpdatePassword
